import {CSSProperties, forwardRef, Ref} from 'react';
import {getBgCN} from '../constant';
import useTypedSelector from '../hook/useTypedSelector';

interface IProps {
  style?: CSSProperties;
  className?: string;
  isCustom?: boolean;
}

// TODO: 처음에는 gradient가 없다가, 스크롤을 내렸을 때 나타나는 페이지 대응 (ex. 작품홈, 이벤트 페이지)
function HeaderGradientV4(
  {style, className, isCustom}: IProps,
  ref: Ref<HTMLDivElement>
) {
  const currentPage = useTypedSelector(state => state.common.layoutProps.page);
  return (
    <div
      ref={ref}
      className={cn(
        'fixed top-0 left-0 right-0 z-navigationBarMinus2',
        className,
        {
          'h-default-gradient-header-height': !isCustom,
          [getBgCN(currentPage)]: !isCustom,
        }
      )}
      style={style}
    />
  );
}

export default forwardRef(HeaderGradientV4);
